"use client";

import { useConnectWallet } from "@web3-onboard/react";
import { FunctionComponent } from "react";

import { Button, SocialMedia } from "@/components";
import { useChain } from "@/hooks";
import { Logo } from "@/icons";

import styles from "./Header.module.css";

export const Header: FunctionComponent = () => {
  const [{ wallet }, connect] = useConnectWallet();
  const { chain } = useChain();

  return (
    <header className={styles.root}>
      <Logo aria-label="AIDeFi" className={styles.logo} />
      <SocialMedia className={styles.socialMedia} />
      <Button
        className={styles.button}
        disabled={wallet === null}
        onClick={() =>
          window.ethereum?.request({
            method: "wallet_watchAsset",
            params: {
              options: {
                address: chain.addresses.xsd,
                decimals: 18,
                image: "https://app.bankx.io/images/token/xsd.jpg",
                symbol: "XSD",
              },
              type: "ERC20",
            },
          })
        }
        wide>
        Add XSD to wallet
      </Button>
      <Button
        className={styles.button}
        disabled={wallet !== null}
        onClick={() => connect()}
        wide>
        Connect wallet
      </Button>
    </header>
  );
};
